import { createContext, useContext } from 'react';

type TalentContextValue = {
  talentId?: string;
};

const TalentContext = createContext<TalentContextValue>({});

export const useTalent = () => useContext(TalentContext);
